import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ErrorList from 'Components/ComponentLibrary/Molecules/ErrorList';
import Message from './Message';
import Header from './Header';

const styles = (theme) => ({
  root: {},
  header: {},
  errorList: {
    marginBottom: theme.spacing(2),
  },
  message: {},
});

const BaseFormLayout = ({
  className,
  classes,
  id,
  onSubmit,
  children,
  errors,
  message,
  title,
  subtitle,
}) => {
  return (
    <form
      id={id}
      className={classNames(classes.root, className)}
      onSubmit={onSubmit}
    >
      <Header
        className={classes.header}
        title={title}
        subtitle={subtitle}
        showIcon
      />
      <ErrorList
        className={classes.errorList}
        errors={errors}
      />
      <Message
        className={classes.message}
        message={message}
      />
      {children}
    </form>
  );
};

BaseFormLayout.defaultProps = {
  className: '',
  subtitle: null,
  errors: [],
  message: null,
};

BaseFormLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  errors: PropTypes.array,
  message: PropTypes.string,
};

export default withStyles(styles)(BaseFormLayout);
